import { getRecordValue, isWeb } from '../utils';

export const mainFont = "'Plus Jakarta Sans', sans-serif";

const regular = 400;
const semi = 600;
const bold = 700;
const extraBold = 800;

export const fontSizes = {
  s: 14,
  m: 16,
  l: 18,
  xl: 24,
  xxl: 32,
} as const;

export type FontSize = keyof typeof fontSizes;

export const fontWeights = {
  regular,
  semi,
  bold,
  extraBold,
};

export type FontWeight = keyof typeof fontWeights;

const getWebCss = (size: FontSize, weight: FontWeight) => {
  return `
  font-family: inherit;
  font-weight: ${getRecordValue(fontWeights, weight)};
  font-size: ${`${getRecordValue(fontSizes, size)}px`};
`;
};

const getNativeCss = (size: FontSize, weight: FontWeight) => {
  const mobileFontWeights: Record<keyof typeof fontWeights, string> = {
    regular: 'PlusJakartaSans-Regular',
    semi: 'PlusJakartaSans-SemiBold',
    bold: 'PlusJakartaSans-Bold',
    extraBold: 'PlusJakartaSans-ExtraBold',
  };
  return `
    font-family: ${getRecordValue(mobileFontWeights, weight)};
    font-size: ${`${getRecordValue(fontSizes, size)}px`};
  `;
};

export const getFontStyle = (
  size: FontSize = 'm',
  weight: FontWeight = 'semi'
) => {
  if (isWeb()) {
    return getWebCss(size, weight);
  } else {
    return getNativeCss(size, weight);
  }
};
